export const POKER_SUIT_COLOR_LOTTIE: [number, number, number, number] = [
  1, 1, 1, 1,
];

export const POKER_SUIT_VIEWPORT = 520;
export const POKER_SUIT_ANIMATION_SIZE = 'min(36vw, 130px)';
export const POKER_HOLD_MS = 900;
export const POKER_TRANSITION_MS = 450;
export const POKER_STACK_TRANSITION_MS = 300;
export const POKER_CARD_COUNT = 4;

export const POKER_LOADING_GRADIENT =
  'linear-gradient(111deg, #5A0404 13.87%, #003D81 86.13%)';

export const POKER_SUIT_HOLD_FRAMES = {
  spade: 10,
  club: 58,
  heart: 104,
  diamond: 150,
} as const;
